
import { actionTypes } from './ActivateDeactivateGateway/constants';
import { actionTypes as downloadReportActionTypes } from '../constants';

export const activateDeactivateGateway = (dispatch, gatewayId) => {
    const datacollectionUnitId = gatewayId; // Assuming gatewayId is the datacollectionUnitId, adjust if needed
    const isActivate = true;
    return dispatch({
        type: actionTypes.ACTIVATE_DEACTIVATE_GATEWAY,
        gatewayId,
        datacollectionUnitId,
        isActivate
    });
};

export const downloadInstallationReport = (dispatch, gatewayId, fileType) => {
    return dispatch({
        type: downloadReportActionTypes.DOWNLOAD_INSTALLATION_REPORT,
        gatewayId,
        fileType
    });
};

export const downloadDiagnosticReport = (dispatch, dcuId) => {
    return dispatch({
        type: downloadReportActionTypes.DOWNLOAD_DIAGNOSTIC_REPORT,
        dcuId
    });
};
